'use client';

import Header from '@/app/components/layout/header/Header';
import SmoothScrolling from '@/app/components/layout/SmoothScrolling';
import TransitionComponent from '@/app/components/layout/TransitionComponent';
import { SessionProvider } from 'next-auth/react';
import { ToastProvider } from './context/ToastContext';
import { SidebarProvider } from './context/SidebarContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { usePathname } from 'next/navigation';
import { useMemo, useEffect } from 'react';

const queryClient = new QueryClient();

export default function Providers({ children }) {
  const pathname = usePathname();
  const bodyClass = useMemo(
    () => (pathname === '/' ? 'home' : pathname.replace(/\//g, '-').replace(/^-|-$/g, '')),
    [pathname]
  );

    useEffect(() => {
    const body = document.body;
    // Remove any old "page-*" class we previously set
    const prev = Array.from(body.classList).find(c => c.startsWith('page-'));
    if (prev && prev !== bodyClass) body.classList.remove(prev);
    // Add the current one if not present
    if (!body.classList.contains(bodyClass)) body.classList.add(bodyClass);
  }, [bodyClass]);

  return (
    <div className={bodyClass}>
      {/* Skip navigation for keyboard users (HHS 9A / WCAG 2.4.1) */}
      <a href="#main" className="visually-hidden-focusable position-absolute top-0 start-0 m-2 p-2 bg-white text-primary z-3">
        Skip to main content
      </a>
      <SessionProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <SidebarProvider>
              {/* Hide Header on public pages (login, registration) */}
              {pathname !== '/login' && !pathname.startsWith('/register') && <Header />}

              <TransitionComponent>
                <main id="main" tabIndex={-1} aria-label="Main content" className="position-relative">
                  {children}
                </main>
              </TransitionComponent>
            </SidebarProvider>
          </ToastProvider>
        </QueryClientProvider>
      </SessionProvider>
    </div>
  );
}